<script>
export default {
  name: 'PendingInvitationsPopup',
  props: {
    invitations_route: {
      type: String,
      required: true
    },
    pending_invitations_route: {
      type: String,
      required: true
    }
  },
  mounted() {
    setTimeout(this.check, 2000);
  },

  methods: {
    check() {
      axios.get(this.pending_invitations_route)
        .then(({ data }) => {
          if (data.inviting_company) {
            Swal.fire({
              title: 'Hooray !!!',
              html:
                `<span class="is-size-4"><b>${data.inviting_company.company_name}</b> is about to share its online courses with you and invites you to join their <b>Student List</b>.</span>`,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'Join'
            }).then(result => {
              if (result.value) {
                location.href = this.invitations_route;
              }
            });
          }          
        });
    }
  },

  render(h) {
    return h();
  }
};
</script>
